/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as IBMColors from './resources/IBMColors.json';

export default class ColorGrid extends Component{

	static propTypes = {
		onColorChange: PropTypes.func,
		color: PropTypes.string
	}

	constructor(props){
		super(props);

		this.state = {
			activeSelector: null
		};

		this.colorNodes = this.generateColorGrid();
		this.blackAndWhite = [
			this.getColorGrid({ backgroundColor: '#000000' }, 'black', true, false ),
			this.getColorGrid({ backgroundColor: '#FFFFFF' }, 'white', true, true )
		];
	}

	generateColorGrid(){
		const colorsArray = [
			IBMColors['Yellow 10'], IBMColors['Orange 10'], IBMColors['Red 10'], IBMColors['Magenta 10'], IBMColors['Purple 10'], IBMColors['Blue 10'], IBMColors['Cyan 10'], IBMColors['Teal 10'], IBMColors['Green 10'], IBMColors['Cool Gray 10'], IBMColors['Gray 10'], IBMColors['Warm Gray 10'],
			IBMColors['Yellow 20'], IBMColors['Orange 20'], IBMColors['Red 20'], IBMColors['Magenta 20'], IBMColors['Purple 20'], IBMColors['Blue 20'], IBMColors['Cyan 20'], IBMColors['Teal 20'], IBMColors['Green 20'], IBMColors['Cool Gray 20'], IBMColors['Gray 20'], IBMColors['Warm Gray 20'],
			IBMColors['Yellow 30'], IBMColors['Orange 30'], IBMColors['Red 30'], IBMColors['Magenta 30'], IBMColors['Purple 30'], IBMColors['Blue 30'], IBMColors['Cyan 30'], IBMColors['Teal 30'], IBMColors['Green 30'], IBMColors['Cool Gray 30'], IBMColors['Gray 30'], IBMColors['Warm Gray 30'],
			IBMColors['Yellow 40'], IBMColors['Orange 40'], IBMColors['Red 40'], IBMColors['Magenta 40'], IBMColors['Purple 40'], IBMColors['Blue 40'], IBMColors['Cyan 40'], IBMColors['Teal 40'], IBMColors['Green 40'], IBMColors['Cool Gray 40'], IBMColors['Gray 40'], IBMColors['Warm Gray 40'],
			IBMColors['Yellow 50'], IBMColors['Orange 50'], IBMColors['Red 50'], IBMColors['Magenta 50'], IBMColors['Purple 50'], IBMColors['Blue 50'], IBMColors['Cyan 50'], IBMColors['Teal 50'], IBMColors['Green 50'], IBMColors['Cool Gray 50'], IBMColors['Gray 50'], IBMColors['Warm Gray 50'],
			IBMColors['Yellow 60'], IBMColors['Orange 60'], IBMColors['Red 60'], IBMColors['Magenta 60'], IBMColors['Purple 60'], IBMColors['Blue 60'], IBMColors['Cyan 60'], IBMColors['Teal 60'], IBMColors['Green 60'], IBMColors['Cool Gray 60'], IBMColors['Gray 60'], IBMColors['Warm Gray 60'],
			IBMColors['Yellow 70'], IBMColors['Orange 70'], IBMColors['Red 70'], IBMColors['Magenta 70'], IBMColors['Purple 70'], IBMColors['Blue 70'], IBMColors['Cyan 70'], IBMColors['Teal 70'], IBMColors['Green 70'], IBMColors['Cool Gray 70'], IBMColors['Gray 70'], IBMColors['Warm Gray 70'],
			IBMColors['Yellow 80'], IBMColors['Orange 80'], IBMColors['Red 80'], IBMColors['Magenta 80'], IBMColors['Purple 80'], IBMColors['Blue 80'], IBMColors['Cyan 80'], IBMColors['Teal 80'], IBMColors['Green 80'], IBMColors['Cool Gray 80'], IBMColors['Gray 80'], IBMColors['Warm Gray 80'],
			IBMColors['Yellow 90'], IBMColors['Orange 90'], IBMColors['Red 90'], IBMColors['Magenta 90'], IBMColors['Purple 90'], IBMColors['Blue 90'], IBMColors['Cyan 90'], IBMColors['Teal 90'], IBMColors['Green 90'], IBMColors['Cool Gray 90'], IBMColors['Gray 90'], IBMColors['Warm Gray 90'],
			IBMColors['Yellow 100'], IBMColors['Orange 100'], IBMColors['Red 100'], IBMColors['Magenta 100'], IBMColors['Purple 100'], IBMColors['Blue 100'], IBMColors['Cyan 100'], IBMColors['Teal 100'], IBMColors['Green 100'], IBMColors['Cool Gray 100'], IBMColors['Gray 100'], IBMColors['Warm Gray 100']
		];

		let colors = [];
		for(let i = 0; i < colorsArray.length; i++){
			const RgbColor = '#' + colorsArray[i];
			let colorStyle = {
				backgroundColor: RgbColor
			};
			colors.push(this.getIndexedColorGrid( colorStyle, i ));
		}
		return colors;
	}

	shouldComponentUpdate(){
		return false;
	}

	setColor(e, color, isGreyScale){
		let newSelector = e.target.firstChild || e.target;
		if(this.state.activeSelector){
			let oldSelector = this.state.activeSelector;
			if ( oldSelector != newSelector ){
				oldSelector.style.display = 'none';
				oldSelector.parentNode.style.borderWidth = '1px';
				oldSelector.parentNode.style.backgroundColor = oldSelector.style.backgroundColor;
			}
		}
		newSelector.style.display = 'block';
		newSelector.parentNode.style.borderWidth = '0px';
		newSelector.parentNode.style.backgroundColor = '#FFFFFF';
		this.setState({ activeSelector: newSelector });
		this.props.onColorChange(color.toUpperCase(), isGreyScale);
	}

	getIndexedColorGrid( colorStyle, i ){
		const isGreyScale = i % 12 >= 9; // column 10 is true grey, 9 and 11 are warm/cool grey, which could work without setting greyscale, but give better results treated as grey
		const needsOutline = i < 36; // somewhat random assertion that the first 3 rows are light enough to warrant an outline
		return this.getColorGrid( colorStyle, i, isGreyScale, needsOutline );
	}
	getColorGrid(colorStyle, identifier, isGreyScale, needsOutline){
		let gridSquareClass = needsOutline ? 'clsColorBoxStyle_white' : 'clsColorBoxStyle';
		return (
			<div id={'gridIndex' + identifier} key={identifier} style={colorStyle} className={gridSquareClass} onClick={element => this.setColor(element, colorStyle.backgroundColor, isGreyScale)}>
				<div id={'gridSelector' + identifier} className='clsSelector' style={{ display: 'none', backgroundColor: colorStyle.backgroundColor }}></div>
			</div>
		);
	}

	render(){
		return(
			<div style={{ display: 'flex', width: '448px' }}>
				<div style={{ display: 'flex', width: '64px' }}>
					{this.blackAndWhite}
				</div>
				<div style={{ display: 'flex', flexWrap: 'wrap', width: '384px' }}>
					{this.colorNodes}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/ColorGrid.js